<template>
  <div class="supervisor-seek" :class = "{'clear-header':isWechatBrowser}">
    <my-header title="优选设计师" v-if="!isWechatBrowser" :showBack="true"></my-header>
    <div class="top-title">优选设计</div>
    <div class="supervisor-flow-part">
      <img class="icon-flow" src="../../assets/designer_flow.png"/>
    </div>
    <img @click="goSupervisorIntro()" class="icon-supervisor-intro" src="../../assets/designer_intro_icon.png"/>
    <div class="general-tab-part">
      <div @click="selectSynthesize()" class="tab-item" :class="{'selected':currentTab == '1'}" style="margin-left:-0.32rem;">
        {{selectedSynthesizeText}}
        <img class="sort" v-if="currentTab != '1'" src="../../assets/icon-supervisor-sort-down.png">
        <img class="active" v-if="currentTab == '1' && isSelectSynthesize" src="../../assets/icon-supervisor-sort-up1.png">
        <img class="active" v-if="currentTab == '1' && !isSelectSynthesize" src="../../assets/icon-supervisor-sort-down1.png">
      </div>
      <div @click="selectArea()" class="tab-item" :class="{'selected':currentTab == '2'}">
        {{selectedAreaText}}
        <img class="sort" v-if="currentTab != '2'" src="../../assets/icon-supervisor-sort-down.png">
        <img class="active" v-if="currentTab == '2' && isSelectArea" src="../../assets/icon-supervisor-sort-up1.png">
        <img class="active" v-if="currentTab == '2' && !isSelectArea" src="../../assets/icon-supervisor-sort-down1.png">
      </div>
    </div>
    <div class="select-part" v-if="showSelectPart && isSelectSynthesize">
      <div class="select-list">
        <div class="select-item" v-for="synthesizeItem in synthesizeList" :class="{'selected':synthesizeItem.value == synthesize}"  @click="updateSynthesize(synthesizeItem)">
          {{synthesizeItem.text}}
        </div>
      </div>
    </div>
    <div class="select-part" v-if="showSelectPart && isSelectArea">
      <div class="area-select-list">
        <div class="select-item" v-for="area in areaList" :class="{'selected':area.id == selectedAreaId}" @click="updateArea(area)">
          {{area.name}}
        </div>
      </div>
    </div>
    <div class="supervisor-item" v-for="(supervisor,index) in supervisorList" :style="(index===0?'paddingTop:0':'')">
      <img class="supervisor-avatar" :src="imgUrl + supervisor.avatar" @click="DetailSupervisor(supervisor)">
      <div class="supervisor-info" @click="DetailSupervisor(supervisor)">
        <div class="first-line">
          <div class="left">
            <div class="name">{{supervisor.name}}</div>
            <div class="score-part">
              <div class="score">{{supervisor.score | serviceScoreConvert}}</div>
            </div>
          </div>
          <div class="designPrice" v-if="supervisor.designPrice">{{supervisor.designPrice}}<span class="unit">元/㎡</span></div>
        </div>
        <div class="appointment-info"><img src="../../assets/icon-appointment-num.png"/>预约名额<span class="num">{{supervisor.spares}}</span></div>
        <div class="less-info">
          <!--            <div class="case-info"><img src="../../assets/icon-case-num.png"/>案例<span class="num">{{supervisor.projectCount}}</span></div>-->
          <div class="case-info" v-if="supervisor.deposit"><img src="../../assets/icon-app-deposit.png"/>订金<span class="num deposit">{{supervisor.deposit}}</span></div>
        </div>
      </div>
      <div v-if="supervisor.spares != 0" class="appoint-btn" @click="openSupervisorReservation(supervisor)">
        预 约
      </div>
      <div v-if="supervisor.spares == 0" class="full-btn" @click="openSupervisorReservation(supervisor)">
        已 满
      </div>
    </div>
    <div v-if="supervisorList.length==0" class="black-page">
      <img src="../../assets/icon-no-img.png">
      <div class="tip">暂无相关设计师!</div>
    </div>
  </div>
</template>
<script>
import {imgUrl,shareIcon} from '../../config'
import {Toast} from 'mint-ui'
import Header from '../../components/header/Header'
import session from '../../utils/Session'
import SupervisorService from '../../service/SupervisorService'
import shareService from '../../service/share/ShareService'
import areaService from '../../service/core/AreaService'

export default {
  name: 'DesignerList',
  components: {
    'my-header': Header,
  },
  data () {
    return {
      synthesize:'0',
      synthesizeList:[{value:0,text:'综合排序'},
        {value:1,text:'评价优选'},
        {value:2,text:'成单数由高到低'},
        {value:3,text:'案例由高到低'},
        {value:4,text:'案例由低到高'}],
      supervisorList:[],
      imgUrl: imgUrl,
      shareIcon:shareIcon,
      isWechatBrowser:this.$verfyBrowserType(),
      areaList:[],
      showSelectPart:false,
      selectedAreaId:'',
      selectedAreaText:'接单区域',
      selected:'1',
      selectedSynthesizeText:'综合排序',
      isSelectArea:false,
      isSelectSynthesize:false,
      currentTab:'1'
    }
  },
  created(){
    if(this.global.synthesize){
      this.synthesize = this.global.synthesize;
      this.global.synthesize = '';
    }
    if(this.global.selectedAreaId){
      this.selectedAreaId = this.global.selectedAreaId;
      this.global.selectedAreaId = '';
    }
    if(this.global.selectedAreaText){
      this.selectedAreaText = this.global.selectedAreaText;
      this.global.selectedAreaText = '';
    }
  },
  beforeMount () {
    document.title = this.$route.meta.title;
    this.getSupervisorList();
    this.loadAreaList();
  },
  beforeRouteLeave(to, from, next) {
    if(to.name == 'Index'){
      this.global.synthesize = '';
      this.global.selectedAreaId = '';
      this.global.selectedAreaText = '';
      from.meta.keepAlive = false;
      this.$destroy();
      next();
    }else {
      this.global.synthesize = this.synthesize;
      this.global.selectedAreaId = this.selectedAreaId;
      this.global.selectedAreaText = this.selectedAreaText;
      from.meta.keepAlive = true;
      next();
    }
  },
  methods: {
    selectArea(){
      this.showSelectPart = true;
      this.isSelectSynthesize = false;
      this.isSelectArea = !this.isSelectArea;
      this.currentTab = '2';
    },
    selectSynthesize(){
      this.showSelectPart = true;
      this.isSelectArea = false
      this.isSelectSynthesize = !this.isSelectSynthesize;
      this.currentTab = '1';
    },
    async updateSynthesize(synthesize){
      this.showSelectPart = !this.showSelectPart;
      this.synthesize = synthesize.value;
      this.selectedSynthesizeText = synthesize.text;
      this.getSupervisorList();
      this.isSelectSynthesize = !this.isSelectSynthesize;
    },
    async updateArea(area){
      this.showSelectPart = !this.showSelectPart;
      this.selectedAreaId = area.id;
      this.selectedAreaText = area.name;
      this.getSupervisorList();
      this.isSelectArea = !this.isSelectArea;
    },
    async loadAreaList(){
      let result = await areaService.getAreaList(2);
      this.areaList = result.data;
    },
    goSupervisorIntro(){
      this.$router.push({name:'SupervisorDesignerIntro'});
    },
    DetailSupervisor(supervisor){
      this.$router.push({name:'DesignerDetail',query:{supervisorId:supervisor.id,supervisorName:supervisor.name}});
    },
    openSupervisorReservation(supervisor){
      if(supervisor.appointmentSwitch != '1'){
        Toast('该设计师暂时不接受预约!');
      }else if(supervisor.appointmentSwitch == '1' && supervisor.spares == 0){
        Toast('该设计师预约已满!');
      }else {
        this.global.synthesize = this.synthesize;
        if(!!this.global.isMiniProgrm ){
          session.isLogin().then(flag => {
            if (flag) {
              wx.miniProgram.navigateTo({url: `/pages/gangmaster/reservation?id=${supervisor.id}&companyId=${supervisor.companyId}&deposit=${supervisor.deposit}&supervisorName=${supervisor.name}&type=6`});
            } else {
              let backUrl = this.$route.fullPath;
              wx.miniProgram.navigateTo({url: `/pages/register/register?h5Url=${encodeURIComponent(backUrl)}`});
            }
          });
        }else {
          this.$router.push({name:'DesignerReservation',query:{id:supervisor.id,supervisorName:supervisor.name,deposit:supervisor.deposit}});
        }
      }
    },
    async getSupervisorList(){
      let { code, data} = await SupervisorService.getSupervisorList('5',this.synthesize,this.selectedAreaId);
      if(code == 0){
        this.supervisorList = [];
        if(this.synthesize != 0){
          this.supervisorList = data;
        } else {
          let closeSwitchDesigners = [];
          let withoutSparesDesigners = [];
          for(let designer of data){
            if(designer.appointmentSwitch != 1){
              closeSwitchDesigners.push(designer);
            }else if(designer.spares == 0){
              withoutSparesDesigners.push(designer);
            }else {
              this.supervisorList.push(designer);
            }
          }
          this.supervisorList = this.supervisorList.concat(closeSwitchDesigners);
          this.supervisorList = this.supervisorList.concat(withoutSparesDesigners);
        }
        for(let supervisor of this.supervisorList){
          if(!supervisor.designPriceMax>0){
            this.$set(supervisor,'designPrice',supervisor.designPriceMin)
          }else {
            this.$set(supervisor,'designPrice',supervisor.designPriceMin +'-'+supervisor.designPriceMax);
          }
        }
      }else {
        Toast('获取设计师列表信息失败');
      }
    },
    async initWechatShare(){
      let title = "水木家居商城设计师排名";// 分享标题
      let desc = "水木设计师，一站式设计师服务，让繁琐的家装变得格外简单！"; // 分享描述
      let link = window.location.href; // 分享链接
      link = link.replace(/#/, '?#');
      await shareService.wechatShare(title,desc,link,this.shareIcon);
    },
  }
}
</script>

<style lang="scss">
@import '../../assets/style/supervisor-list.scss';
.appointment-info {
  justify-content: flex-start;
  align-items: center;
}
.supervisor-seek {
  background-color: white;
  font-size: 0.36rem;
  .select-tab{
    height: 0.9rem;
    line-height: 0.93rem;
  }
}
.supervisor-flow-part{
  width: 100%;
  height: 3.2rem;
  text-align: center;
  background-color: #f8f8f8;
  padding:0.25rem;
  box-sizing: border-box;
  .icon-flow{
    width: 100%;
    height: 100%;
  }
}
</style>

